<template>
	<div class="notification-alarm-bell-svgrepo-com-1" @click="goToNotifications">
		<img
			class="vector-252"
			src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-66.svg"
			alt="Vector"
		/>
		<img
			class="vector-253"
			src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-67.svg"
			alt="Vector"
		/>
		<div class="view-372">
			<div class="rectangle-82-6"></div>
			<div class="x1-20 poppins-semi-bold-white-10px">
				{{ notificationCount }}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'NotificationAlarmBellSvgrepoCom1',
	props: {
		notificationCount: {
			type: Number,
			default: 5,
		},
	},
	methods: {
		goToNotifications() {
			// Переход на страницу уведомлений
      alert('Уведомления будут реализованы в следующем обновлении!');
		},
	},
}
</script>

<style>
.notification-alarm-bell-svgrepo-com-1,
.notification-alarm-bell-svgrepo-com-1-1,
.notification-alarm-bell-svgrepo-com-1-2,
.notification-alarm-bell-svgrepo-com-1-3,
.notification-alarm-bell-svgrepo-com-1-4,
.notification-alarm-bell-svgrepo-com-1-5,
.notification-alarm-bell-svgrepo-com-1-6,
.notification-alarm-bell-svgrepo-com-1-7,
.notification-alarm-bell-svgrepo-com-1-8,
.notification-alarm-bell-svgrepo-com-1-9,
.notification-alarm-bell-svgrepo-com-1-10,
.notification-alarm-bell-svgrepo-com-1-11,
.notification-alarm-bell-svgrepo-com-1-12,
.notification-alarm-bell-svgrepo-com-1-13,
.notification-alarm-bell-svgrepo-com-1-14 {
	height: 32px;
	left: 249px;
	overflow: hidden;
	position: absolute;
	top: 1px;
	width: 32px;
	cursor: pointer;
	transition: transform 0.2s ease, opacity 0.2s ease;
}

.notification-alarm-bell-svgrepo-com-1:hover {
  opacity: 0.8;
}
/* Отменить для view-372 */
.notification-alarm-bell-svgrepo-com-1:hover .view-372 {
  opacity: 1;
}

.notification-alarm-bell-svgrepo-com-1:active {
	transform: scale(0.95);
}


.vector-252,
.vector-254,
.vector-256,
.vector-258,
.vector-260,
.vector-262,
.vector-264,
.vector-266,
.vector-268,
.vector-270,
.vector-272,
.vector-274,
.vector-276,
.vector-278,
.vector-280 {
	height: 68.75%;
	left: 12.5%;
	position: absolute;
	top: 9.38%;
	width: 74.98%;
}

.vector-253,
.vector-255,
.vector-257,
.vector-259,
.vector-261,
.vector-263,
.vector-265,
.vector-267,
.vector-269,
.vector-271,
.vector-273,
.vector-275,
.vector-277,
.vector-279,
.vector-281 {
	height: 12.5%;
	left: 37.5%;
	position: absolute;
	top: 78.12%;
	width: 25%;
}

.view-372,
.view-373,
.view-374,
.view-375,
.view-376,
.view-377,
.view-378,
.view-379,
.view-380,
.view-381,
.view-382,
.view-383,
.view-384,
.view-385,
.view-386 {
	height: 20px;
	left: 37.5%;
	position: absolute;
	top: 0;
	width: 68.75%;
}

.rectangle-82-6,
.rectangle-82-7,
.rectangle-82-8,
.rectangle-82-9,
.rectangle-82-10,
.rectangle-82-11,
.rectangle-82-12,
.rectangle-82-13,
.rectangle-82-14,
.rectangle-82-15,
.rectangle-82-16,
.rectangle-82-17,
.rectangle-82-18,
.rectangle-82-19,
.rectangle-82-20 {
	aspect-ratio: 1;
	background-color: var(--coral-red);
	border: 1.5px solid;
	border-color: var(--white);
	border-radius: 60px;
	height: 20px;
	left: 0;
	position: absolute;
	top: 0;
	width: 90.91%;
}

.x1-20,
.x1-21,
.x1-22,
.x1-23,
.x1-24,
.x1-25,
.x1-26,
.x1-27,
.x1-28,
.x1-29,
.x1-30,
.x1-31,
.x1-32,
.x1-33,
.x1-34 {
	height: 75%;
	left: 31.82%;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	top: 15%;
	width: 31.82%;
}
</style>
